<template>
  <v-form @submit="preventSubmit">
    <v-text-field
      v-model="form.text"
      label="Text"
      prepend-icon="mdi-form-textbox"
    ></v-text-field>
    <v-checkbox v-model="form.openVote" label="Öppen votering"></v-checkbox>
    <v-checkbox
      v-if="weightedVoteOptional"
      v-model="form.weightedVote"
      label="Viktade röster enligt andelstal"
    ></v-checkbox>
    <v-select
      v-model="form.type"
      label="Svarsalternativ"
      :items="types"
    ></v-select>
    <div v-if="allowedAlternatives">
      <v-card
        dense
        v-for="(alternative, index) in form.alternatives"
        :key="index"
        style="margin-top: 3px;"
      >
        <v-card-title class="subtitle-2" style="padding: 3px 15px">
          {{ alternative }}
          <v-spacer></v-spacer>
          <v-btn @click="removeAlternative(index)" icon
            ><v-icon>mdi-delete</v-icon></v-btn
          >
        </v-card-title>
      </v-card>

      <v-row>
        <v-col>
          <v-text-field
            v-model="newAlternative"
            label="Nytt alternativ"
            @keyup.enter="addAlternative"
          ></v-text-field>
        </v-col>
        <v-col
          style="display: flex; flex-grow: 0; flex-shrink: 0; align-items: center; justify-content: center;"
        >
          <v-btn icon @click="addAlternative">
            <v-icon>
              mdi-plus
            </v-icon>
          </v-btn>
        </v-col>
      </v-row>
    </div>
    <div v-if="allowedChoices">
      Max valbara alternativ
      <v-slider
        v-model="form.choices"
        class="align-center"
        :max="form.alternatives.length || 1"
        :min="1"
        thumb-label="always"
        hide-details
      ></v-slider>
      <v-checkbox
        v-model="form.forceChoices"
        label="Tvinga användning av alla valbara alternativ"
      ></v-checkbox>
    </div>
  </v-form>
</template>

<script>
const form = {
  text: "",
  openVote: true,
  type: "yesno",
  alternatives: [],
  choices: "1",
  forceChoices: false,
  weightedVote: false
};

export default {
  props: {
    decisionPoint: Object,
    weightedVoteOptional: Boolean
  },
  data() {
    return {
      form: { ...form },
      newAlternative: "",
      types: [
        { value: "yesno", text: "Ja/Nej" },
        { value: "simple", text: "Alternativ med ett svar" },
        { value: "multi", text: "Alternativ med flera svar" }
      ]
    };
  },
  computed: {
    allowedAlternatives() {
      return this.form.type === "multi" || this.form.type === "simple";
    },
    allowedChoices() {
      return this.form.type === "multi";
    },
    alternativesLength() {
      return this.form.alternatives.length;
    }
  },
  watch: {
    allowedAlternatives(value) {
      if (!value) {
        this.form.alternatives = [];
      }
    },
    alternativesLength(value) {
      if (this.form.choices > value) {
        this.form.choices = "1";
      }
    }
  },
  methods: {
    resetForm(decisionPoint) {
      if (!decisionPoint) {
        return;
      }
      const data = {
        text: decisionPoint.text,
        openVote: decisionPoint.openVote,
        type: decisionPoint.type,
        alternatives: decisionPoint.alternatives || [],
        choices: decisionPoint.choices,
        forceChoices: decisionPoint.forceChoices
      };
      this.form = { ...this.form, ...data };
      if (this.weightedVoteOptional) {
        this.form.weightedVote = !decisionPoint.forceUnweighted;
      }
    },
    close() {
      this.form = { ...form };
      this.$emit("close");
      this.resetForm(this.decisionPoint);
    },
    addAlternative() {
      if (!this.newAlternative) {
        return;
      }

      this.form.alternatives.push(this.newAlternative);
      this.newAlternative = "";
    },
    removeAlternative(index) {
      this.form.alternatives.splice(index, 1);
    },
    preventSubmit(event) {
      event.preventDefault();
    }
  },
  mounted() {
    this.form.alternatives = [];
    this.resetForm(this.decisionPoint);
  }
};
</script>

<style></style>
